/**
 * localStorageの読み書きを行う共通ロジック
 */
export const useLocalStorageLogic = () => {
  /**
   * localStorageから値を取得する
   *
   * @param key 取得するキー
   * @returns 保存されている値。未保存またはブラウザ環境でない場合はnull
   */
  const getItem = (key: string): string | null => {
    if (typeof window === 'undefined') {
      return null;
    }
    return localStorage.getItem(key);
  };

  /**
   * localStorageに値を保存する
   *
   * @param key 保存するキー
   * @param value 保存する値
   */
  const setItem = (key: string, value: string): void => {
    if (typeof window === 'undefined') {
      return;
    }
    localStorage.setItem(key, value);
  };

  /**
   * localStorageから値を削除する
   *
   * @param key 削除するキー
   */
  const removeItem = (key: string): void => {
    if (typeof window === 'undefined') {
      return;
    }
    localStorage.removeItem(key);
  };

  return {
    getItem,
    setItem,
    removeItem,
  };
};
